import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as IconReportSimilarity } from '../../public/images/svg/icon_report_similarity.svg';
import Button from '../Button/Button';
import { COPYSCAPE } from './enum';

const Copyscape = ({ data = null, onClick }) => {
  if (!data) {
    return null;
  }

  const { bgColor, icon } = COPYSCAPE[data?.semaphore];

  return (
    <div
      className="flex gap-1 justify-end items-start"
      data-testid="generated-prompt-copyscape-result-wrapper"
    >
      <div
        key="generated-prompt-copyscape-result"
        data-testid="generated-prompt-copyscape-result"
        className={` w-44 p-4 ${bgColor} flex gap-4 text-grey-400 capitalize font-medium`}
      >
        {icon}
        <span>Copyscape</span>
      </div>
      <Button
        type="button"
        className="bg-transparent p-4 text-purple-200 flex gap-4 capitalize font-medium"
        name="generated-prompt-copyscape-report"
        onClick={onClick}
        key="generated-prompt-copyscape-report"
        dataTest="generated-prompt-copyscape-report"
        icon={<IconReportSimilarity />}
        label="Copyscape Report"
      />
    </div>
  );
};

Copyscape.propTypes = {
  data: PropTypes.shape({
    semaphore: PropTypes.string,
    result: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        percentmatched: PropTypes.number,
        url: PropTypes.string,
        textsnippet: PropTypes.string,
        viewurl: PropTypes.string
      })
    )
  }),
  onClick: PropTypes.func
};

export default Copyscape;
